import {
  ENABLE_ACTIVITIES_V2,
  ENABLE_CONTRACTS_V2,
  ENABLE_CUSTOMERS_V2,
  ENABLE_DAILY_TRACKING_V2,
  ENABLE_HOME_V2,
  ENABLE_MONTHLY_MNG_VIEW_V2,
  ENABLE_MONTHLY_PM_VIEW_V2,
  ENABLE_MY_MONTH_V2,
  ENABLE_PROFILE_V2,
  ENABLE_PROJECTS_V2,
  ENABLE_USERS_V2,
  ENABLE_WORKLOGS_V2,
} from '../config/local.config';

/** Pagine con una versione V2 attivabile dal menu utente: percorso classico → percorso V2 (solo con il flag attivo). */
export const V2_PAGES = [
  { path: '/', v2Path: '/home-v2', enabled: ENABLE_HOME_V2 },
  { path: '/daily-tracking', v2Path: '/daily-tracking-v2', enabled: ENABLE_DAILY_TRACKING_V2 },
  { path: '/monthly-user-view', v2Path: '/monthly-user-view-v2', enabled: ENABLE_MY_MONTH_V2 },
  { path: '/monthly-mng-view', v2Path: '/monthly-mng-view-v2', enabled: ENABLE_MONTHLY_MNG_VIEW_V2 },
  { path: '/monthly-people-mng-view', v2Path: '/monthly-people-mng-view-v2', enabled: ENABLE_MONTHLY_PM_VIEW_V2 },
  { path: '/tracking-list-user', v2Path: '/tracking-list-user-v2', enabled: ENABLE_WORKLOGS_V2 },
  { path: '/list-tracking-view', v2Path: '/list-tracking-view-v2', enabled: ENABLE_WORKLOGS_V2 },
  { path: '/list-tracking-people-mng-view', v2Path: '/list-tracking-people-mng-view-v2', enabled: ENABLE_WORKLOGS_V2 },
  { path: '/users', v2Path: '/users-v2', enabled: ENABLE_USERS_V2 },
  { path: '/customers', v2Path: '/customers-v2', enabled: ENABLE_CUSTOMERS_V2 },
  { path: '/projects', v2Path: '/projects-v2', enabled: ENABLE_PROJECTS_V2 },
  { path: '/contracts', v2Path: '/contracts-v2', enabled: ENABLE_CONTRACTS_V2 },
  { path: '/activities', v2Path: '/activities-v2', enabled: ENABLE_ACTIVITIES_V2 },
  { path: '/profile', v2Path: '/profile-v2', enabled: ENABLE_PROFILE_V2 },
].filter((p) => p.enabled);

export const HAS_V2_PAGES = V2_PAGES.length > 0;

const storageKey = (userKey) => `runtime.v2Pages.${String(userKey).toLowerCase()}`;

/** Preferenza dell'utente (salvata nel browser, per utente). Spenta di default. */
export function readV2Pages(userKey) {
  if (!HAS_V2_PAGES || !userKey) return false;
  try {
    return localStorage.getItem(storageKey(userKey)) === 'on';
  } catch (e) {
    return false;
  }
}

const themeKey = (userKey) => `runtime.theme.${String(userKey).toLowerCase()}`;
const THEME_PREFS = ['light', 'dark', 'oled', 'system'];

/** Tema scelto dall'utente per le pagine V2 ('light' | 'dark' | 'oled' | 'system'), salvato nel browser. Chiaro di default. */
export function readThemePref(userKey) {
  if (!userKey) return 'light';
  try {
    const value = localStorage.getItem(themeKey(userKey));
    return THEME_PREFS.includes(value) ? value : 'light';
  } catch (e) {
    return 'light';
  }
}

export function writeThemePref(userKey, value) {
  if (!userKey) return;
  try {
    localStorage.setItem(themeKey(userKey), value);
  } catch (e) {
    // localStorage non disponibile: la scelta vale solo fino al ricaricamento della pagina
  }
}

export function writeV2Pages(userKey, enabled) {
  if (!userKey) return;
  try {
    localStorage.setItem(storageKey(userKey), enabled ? 'on' : 'off');
  } catch (e) {
    // localStorage non disponibile: la scelta vale solo fino al ricaricamento della pagina
  }
}

// Invito a provare il nuovo design (Home classica): "Not now", o il ritorno al design classico, lo nasconde per 30 giorni
const bannerKey = (userKey) => `runtime.v2Banner.${String(userKey).toLowerCase()}`;
const BANNER_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

export function isV2BannerSnoozed(userKey) {
  if (!userKey) return false;
  try {
    return Number(localStorage.getItem(bannerKey(userKey))) > Date.now();
  } catch (e) {
    return false;
  }
}

export function snoozeV2Banner(userKey) {
  if (!userKey) return;
  try {
    localStorage.setItem(bannerKey(userKey), String(Date.now() + BANNER_SNOOZE_MS));
  } catch (e) {
    // localStorage non disponibile: l'invito torna al prossimo caricamento
  }
}
